import { gql, TypedDocumentNode } from '@common/hooks';
import { SimpleFileFragment, SimpleFileFragmentType } from '@common/graphql';

export const OrganizationSupplierAttachmentsQuery: TypedDocumentNode<
  OrganizationSupplierAttachmentsQueryResponse,
  OrganizationSupplierAttachmentsQueryVariables
> = gql`
  query OrganizationSupplierAttachments($supplierId: ID!) {
    organizationSupplierAttachments(supplierId: $supplierId) {
      id
      fileName
      fileExtension
      expired
      expiresOn
      file {
        ...SimpleFileFragment
      }
    }
  }
  ${SimpleFileFragment}
`;

type OrganizationSupplierAttachmentsQueryVariables = {
  supplierId: string;
};

type OrganizationSupplierAttachmentsQueryResponse = {
  organizationSupplierAttachments: {
    id: string;
    fileName: string;
    expired: boolean;
    expiresOn?: string;
    fileExtension: string;
    file: SimpleFileFragmentType;
  }[];
};
